export const PROMO_TYPES = ['sbotd', 'pro'];
export const SUBSCRIPTION_TYPES = {
  sbotd: 'SPECIAL_BUY_OF_THE_DAY',
  pro: 'PRO',
};
export const SUCCESS_MESSAGE = 'Thanks for signing up! You\'ll receive your first specials email soon.';
export const INVALID_EMAIL_MESSAGE = 'Please format your email as yourname@email.com';
export const PLACEHOLDER = 'Enter your email';
export const HEADER = 'Join our specials mailing list';
export const SOURCE_ID = 'SBOTD_WEB';
export const SUCCESS_STATUS = 'Success';

// @TODO: need UX
export const SERVICE_ERROR_MESSAGE = 'An error occured. Please try again.';
